import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as OrderActions from './order.actions';
import { map, mergeMap, tap, catchError, of } from 'rxjs';
import OrderService from '../../services/OrderService';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class OrderEffects {
  getOrderById$;
  getReflexOrderById$;
  getReflexOrders$;
  useCoins$;
  getOrdersByMe$;
  getOrdersByCustomerId$;
  getPendingOrders$;
  changeOrderStatus$;

  constructor(private actions$: Actions, private service: OrderService, private snackBar: MatSnackBar) {
    // Removed getOrders$ (frontend no longer fetches local orders list)
    this.getReflexOrders$ = createEffect(() =>
      this.actions$.pipe(
        ofType(OrderActions.getReflexOrders),
        mergeMap(({ filters }) =>
          this.service
            .getReflexOrders(filters)
            .pipe(
              map((orders) => OrderActions.getReflexOrdersSuccess({ orders }))
            )
        )
      )
    );
    this.getOrdersByMe$ = createEffect(() =>
      this.actions$.pipe(
        ofType(OrderActions.getOrdersByMe),
        mergeMap(() =>
          this.service.getOrdersByMe().pipe(
            map((orders) => OrderActions.getOrdersByMeSuccess({ orders }))
          )
        )
      )
    );
    this.getOrdersByCustomerId$ = createEffect(() =>
      this.actions$.pipe(
        ofType(OrderActions.getOrdersByCustomerId),
        mergeMap(({ customerId }) =>
          this.service.getOrdersByCustomerNo(customerId).pipe(
            map((orders) => OrderActions.getOrdersByCustomerIdSuccess({ orders }))
          )
        )
      )
    );
    this.getPendingOrders$ = createEffect(() =>
      this.actions$.pipe(
        ofType(OrderActions.getPendingOrders),
        mergeMap(() =>
          this.service.getPendingOrders().pipe(
            map((orders) => OrderActions.getPendingOrdersSuccess({ orders }))
          )
        )
      )
    );
    this.getOrderById$ = createEffect(() =>
      this.actions$.pipe(
        ofType(OrderActions.setSelectedOrder),
        mergeMap(({ id }) =>
          this.service
            .getOrderById(parseInt(id, 10))
            .pipe(
              map((order) => OrderActions.setSelectedOrderSuccess({ order })),
              catchError(() => of(OrderActions.setSelectedOrderFailure()))
            )
        )
      )
    );
    this.getReflexOrderById$ = createEffect(() =>
      this.actions$.pipe(
        ofType(OrderActions.getReflexOrderById),
        mergeMap(({ id }) =>
          this.service.getReflexOrderById(id).pipe(
            map((order) => OrderActions.getReflexOrderByIdSuccess({ order }))
          )
        )
      )
    );
    this.useCoins$ = createEffect(() =>
      this.actions$.pipe(
        ofType(OrderActions.useCoins),
        mergeMap(({ userName, reflexId, coins }) =>
          this.service
            .useCoins(userName, reflexId, coins)
            .pipe(
              map((order) => OrderActions.useCoinsSuccess({ order })),
              tap(() => {
                this.snackBar.open('Coins erfolgreich verwendet!', 'Schließen');
              }),
              catchError((error) => {
                const message =
                  error?.error?.message ?? 'Coins konnten nicht verwendet werden.';
                this.snackBar.open(message, 'Schließen');
                return of(OrderActions.useCoinsFailure({ error }));
              })
            )
        )
      )
    );
    this.changeOrderStatus$ = createEffect(() =>
      this.actions$.pipe(
        ofType(OrderActions.changeOrderStatus),
        mergeMap(({ orderId, action }) =>
          this.service.changeOrderStatus(orderId, action).pipe(
            map((order) => OrderActions.changeOrderStatusSuccess({ order })),
            tap(() => {
              this.snackBar.open(
                action === 'approve' ? 'Auftrag genehmigt!' : 'Auftrag abgelehnt!',
                'Schließen'
              );
            })
          )
        )
      )
    );
  }
}
